const floatingBtn = document.getElementById("floatingBtn");
const footerContainer = document.getElementById("shopify-section-footer");

window.addEventListener("scroll", () => {
  const scrollY = window.scrollY;
   const footerTop = footerContainer.offsetTop;
  const footerHeight = footerContainer.offsetHeight;
   const viewportHeight = window.innerHeight;
  if (scrollY > 800 && scrollY + viewportHeight < footerTop + footerHeight - 300) {
    floatingBtn.classList.add("visible");
  } else {
    floatingBtn.classList.remove("visible");
  }
});


if (window.scrollY > 800) {
  floatingBtn.classList.add("visible");
}
